import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f377a534"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "desktop-restaurants",
  class: "company-header__companies-dropdown desktop-item"
}, null, -1))
const _hoisted_3 = { class: "company-header__left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "mobile-restaurants",
  class: "company-header__companies-dropdown mobile-item"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "header-search",
  class: "company-header__search search mobile-item"
}, null, -1))
const _hoisted_6 = { class: "company-header__right" }
const _hoisted_7 = { class: "company-header__counters counters" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "counter__icon--bonus" }, null, -1))
const _hoisted_9 = { class: "counter__count" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "counter__icon--order-price" }, null, -1))
const _hoisted_11 = { class: "counter__count" }
const _hoisted_12 = { class: "counter__count" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "car",
  class: "counter__icon--car"
}, null, -1))
const _hoisted_14 = { class: "counter__count" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "cart",
  class: "counter__icon--order"
}, null, -1))
const _hoisted_16 = { class: "counter__count" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "counter__icon--favorite" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HamburgerMenu = _resolveComponent("HamburgerMenu")!
  const _component_UserPanel = _resolveComponent("UserPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_HamburgerMenu, {
        class: "company-header__menu menu mobile-item",
        pages: _ctx.pages,
        "has-delivery-zone": _ctx.companyStore.activeCompany.hasDeliveryZone
      }, null, 8, ["pages", "has-delivery-zone"]),
      _hoisted_4,
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_UserPanel),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.authStore.bonusInfo)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "counters__bonuses counter desktop-item",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLoyalty && _ctx.goLoyalty(...args)))
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.authStore.bonusInfo.balance), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.orderStore.activeOrder?.totalPrice && _ctx.orderStore.activeOrder?.totalPrice !== '0')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "counters__order-price counter desktop-item",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToCart && _ctx.goToCart(...args)))
            }, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.orderStore.activeOrder?.totalPrice)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authStore.ordersInDeliveryCount)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "counters__in-delivery counter",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToDelivery && _ctx.goToDelivery(...args)))
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.authStore.ordersInDeliveryCount), 1),
              _hoisted_13
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "counters__order counter",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToCart && _ctx.goToCart(...args)))
        }, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.orderStore.totalItemsQuantity), 1),
          _hoisted_15
        ]),
        (_ctx.authStore?.activeUser)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "counters__favorites counter",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterByFavorites && _ctx.filterByFavorites(...args)))
            }, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.favoriteStore.productsCount), 1),
              _hoisted_17
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}